import React from "react";
import { UiButton } from "../common/UiButton";

export const SuccessMessagePopup = (props) => {
  return (
    <>
      <div
        className={
          props.className ? props.className : "df-success-message-popup"
        }
      >
        {props.icon}
        <p>{props.message}</p>
        {props.secondMessage && (
          <p className="df-confirmation-message-popup-success">
            {props.secondMessage}
          </p>
        )}
        <UiButton
          className={
            props.buttonClass ? props.buttonClass : "df-ui-dark-bg-btn"
          }
          name={props.buttonText}
          onClick={props.buttonOnClick}
        />
      </div>
    </>
  );
};

export const SuccessPopup = (props) => {
  return (
    <>
      <div
        className={
          props.className ? props.className : "df-success-message-popup"
        }
      >
        {props.icon}
        <h3 className="df-confirmation-message-popup__message">
          {props.message}
        </h3>
        {props.children}
        <UiButton
          className={
            props.buttonClass ? props.buttonClass : "df-ui-dark-bg-btn"
          }
          name={props.buttonText}
          onClick={props.buttonOnClick}
        />
      </div>
    </>
  );
};
